import { formatNumber } from "../../../../utilities/functions";
import { useUser } from "../../../../context/UserContext";
import BadgeIcon from "../../../../icon/BadgeIcon";
import ListTooltip from "../../../../ui/ListTooltip/ListTooltip";
import Card from "../../../Card/Card";
import classes from "./TradingObjective.module.css";
import ProgressBar from "../../../../ui/ProgressBar";
import useWindowDimensions from "../../../../hooks/getWindowDimensions";

const TradingObjective = ({ showProgressBar }) => {
  const { user } = useUser();
  const { height, width } = useWindowDimensions();
  console.log("WANT TO SEE USER", user);

  const stats = [
    {
      title: "Daily Loss Limit",
      maximum: `Max Loss Limit: $${
        user.trackingStatistics
          ? formatNumber(user.trackingStatistics?.dailyLossLimit?.maxLossLimit)
          : 0
      }`,
      result: `Today’s Permitted Loss: $${
        user.trackingStatistics
          ? formatNumber(
              user.trackingStatistics?.dailyLossLimit?.todayPermittedLoss
            )
          : 0
      }`,
      info: "This value represents the lowest equity drop recorded in a single day. The daily loss limit includes both open and closed positions.",
      status: user.trackingStatistics
        ? user.trackingStatistics?.dailyLossLimit?.status
        : "Ongoing",
    },
    {
      title: "Maximum Loss Limit",
      maximum: `Max loss limit: $${
        user.trackingStatistics
          ? formatNumber(
              user.trackingStatistics?.maximumLossLimit?.maxLossLimit
            )
          : 0
      }`,
      result: `Maximimum permitted Loss: $${
        user.trackingStatistics
          ? formatNumber(
              user.trackingStatistics?.maximumLossLimit?.maxPermittedLoss
            )
          : 0
      }`,
      info: "This section displays the lowest equity during your active trades for the current cycle.",
      status: user.trackingStatistics
        ? user.trackingStatistics?.maximumLossLimit?.status
        : "Ongoing",
    },
    // {
    //   title: "Rolling Payout Cap",
    //   maximum: "10% monthly",
    //   result: "3%",
    //   info: "You can earn up to 10% profit each month. The profit cap resets monthly, but the timing depends on when you hit the limit. If you reach 10% in a month, your cap resets 30 days after hitting the limit, not at the start of the next month.",
    // },
    {
      title:
        user?.account?.userStage === 3
          ? "Rolling Payout Cap"
          : "Minimum Trading Days",
      maximum: user?.account?.userStage === 3 ? "Maximum: 10% monthly" : `Minimum: ${
        user.trackingStatistics
          ? user.trackingStatistics?.minimumTradingDays?.minimum
          : 5
      } days`,
      result: user?.account?.userStage === 3 ? `Current results: ${(user?.account?.rollingPayoutCap.currentUsed / (user?.account?.initBalance * 0.1)) * 100}%` : `Current results: ${
        user.trackingStatistics
          ? user.trackingStatistics?.minimumTradingDays?.currentResult
          : 0
      } days`,
      info:
        user?.account?.userStage === 3 ? (
          <div className={classes.infoText}>
            <lu>
              <li>You can earn up to 10% profit each month.</li>
              <li>
                The profit cap resets monthly, but the timing depends on when
                you hit the limit.
              </li>
              <li>
                If you reach 10% in a month, your cap resets 30 days after
                hitting the limit, not at the start of the next month.
              </li>
            </lu>
            <div className="my-3">Example</div>
            <lu>
              <li>Trader A makes 5% in January. On February 1st, their profit cap resets to zero.</li>
<li>Trader B hits 10% on January 17th. Their cap resets on February 17th, 30 days later.</li>
</lu>

          </div>
        ) : (
          "Traders must open at least one trade on separate days for a minimum of 4 days."
        ),
      status: user.trackingStatistics
        ? user.trackingStatistics?.minimumTradingDays?.status
        : "Ongoing",
    },
    {
      title: "Profit Target",
      maximum: `Minimum: $${
        user.trackingStatistics
          ? formatNumber(user.trackingStatistics?.profitTarget?.minimum)
          : 0
      }`,
      result: `Current Result: $${
        user.trackingStatistics
          ? formatNumber(user.trackingStatistics?.profitTarget?.currentResult)
          : 0
      }`,
      info: "The profit you need to make as a result of your closed positions",
      status: user.trackingStatistics
        ? user.trackingStatistics?.profitTarget?.status
        : "Ongoing",
    },
  ];

  return (
    <div className="row">
      {(user?.account?.userStage === 3 ? stats.slice(0, -1) : stats).map(
        (item, i) => (
          <div className={`col-md-6 ${(i === 2 || i === 3 || (width <= 768 && i === 1)) && "mt-3"}`} key={i}>
            <Card
              className={`${classes.statsCard} d-flex justify-content-between`}
            >
              <div className="d-flex gap-3">
                <BadgeIcon />
                <div>
                  <ListTooltip
                    className={classes.titleText}
                    text={item.title}
                    info={item.info}
                    index={i}
                  />
                  <div className={classes.subText}>
                    {/* {i === 2 ? "Maximum: " : "Max Loss Limit: "} */}
                    {item.maximum}
                  </div>
                  <div className={classes.resultText}>
                    {/* {i === 0
                    ? "Today’s Permitted Loss: "
                    : i === 1
                    ? "Maximum Permitted Loss: "
                    : "Current Results: "} */}
                    {item.result}
                  </div>
                  {width <= 768 && <div className="mt-3">
                {i === 2 && (user?.account?.userStage === 3) ? 
                   (
                    <ProgressBar progress={(user?.account?.rollingPayoutCap.currentUsed / (user?.account?.initBalance * 0.1)) * 100} />
                  ) : (
                    <button
                      style={{
                        color:
                          item.status === "Passed"
                            ? "linear-gradient(89.84deg, #43FF00 0%, #B6FF9C 99.73%)"
                            : item.status === "Failed" && "#970B0B",
                      }}
                    >
                      {item.status}
                    </button>
                  )}
              </div>}
                </div>
              </div>
              {width > 768 && <div>
                {i === 2 && (user?.account?.userStage === 3) ? 
                   (
                    <ProgressBar progress={(user?.account?.rollingPayoutCap.currentUsed / (user?.account?.initBalance * 0.1)) * 100} />
                  ) : (
                    <button
                      style={{
                        color:
                          item.status === "Passed"
                            ? "linear-gradient(89.84deg, #43FF00 0%, #B6FF9C 99.73%)"
                            : item.status === "Failed" && "#970B0B",
                      }}
                    >
                      {item.status}
                    </button>
                  )}
              </div>}
            </Card>
          </div>
        )
      )}
    </div>
  );
};

export default TradingObjective;
